import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Diagnostic from "@/pages/Diagnostic";
import Dashboard from "@/pages/Dashboard";
import Roadmap from "@/pages/Roadmap";
import PnLDecoder from "@/pages/PnLDecoder";
import ProfitCalculator from "@/pages/ProfitCalculator";
import Lessons from "@/pages/Lessons";
import Pricing from "@/pages/Pricing";
import Welcome from "@/pages/Welcome";
import Admin from "@/pages/Admin";
import PartnersAdmin from "@/pages/PartnersAdmin";

function Loading() {
  return (
    <div className="grid min-h-screen place-items-center bg-[#FAF9F6]">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-neutral-300 border-t-[var(--tenant-primary)]" />
    </div>
  );
}

function Protected({ children, wrap = true }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return wrap ? <Layout>{children}</Layout> : children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
      <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
      <Route path="/diagnostic" element={<Diagnostic />} />
      <Route path="/welcome" element={<Protected wrap={false}><Welcome /></Protected>} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/roadmap" element={<Protected><Roadmap /></Protected>} />
      <Route path="/pnl-decoder" element={<Protected><PnLDecoder /></Protected>} />
      <Route path="/calculator" element={<Protected><ProfitCalculator /></Protected>} />
      <Route path="/lessons" element={<Protected><Lessons /></Protected>} />
      <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="/admin/partners" element={<Protected><PartnersAdmin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
